<div class="section over-hide ">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="section-1400 pt-xl-4">
            <div class="container-fluid padding-top-40">
                <div class="row justify-content-center">
                    <div class="card-body p-0">
                        <div class="row ">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-9 ">
                                        <h5 class="mb-3">NEC Minutes of Meeting</h5>
                                    </div>

                                </div>

                                <div class="col-12 py-3 ">
                                    <div class="section divider one-dashed"></div>
                                </div>

                                <div class="col-xl-12 card mb-5">
                                    <div class="row">


                                        <!-- MOMs Table -->
                                      <div class="col-12 table-responsive rana-table-flat">
                                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table rana-table">
                                            <thead>
                                            <tr>
                                                <th>Date and Time</th>
                                                <th>Created By</th>
                                                <th>Title</th>
                                            </tr>
                                            </thead>
                                            <tbody></tbody>
                                        </table>
                                      </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="modal fade" id="modal-view-mom" tabindex="-1">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content rana-mom-modal" *ngIf="selectedMom">

                                <button type="button" class="close rana-mom-close" data-dismiss="modal">
                                    <i class="uil uil-multiply"></i>
                                </button>

                                <div class="rana-mom-header">
                                    <div class="rana-avatar rana-mom-avatar">{{ momInitials(selectedMom.createdByName) }}</div>
                                    <div class="rana-mom-header-text">
                                        <h6 class="rana-mom-title">{{ selectedMom.title }}</h6>
                                        <div class="rana-mom-meta">
                                            <span>{{ selectedMom.createdByName }}</span>
                                            <span class="rana-mom-meta-dot">&middot;</span>
                                            <span>{{ selectedMom.createdDate | date: 'mediumDate' }}</span>
                                            <span class="rana-badge" [ngClass]="selectedMom.visible ? 'rana-badge-success' : 'rana-badge-neutral'">
                                                <i class="uil uil-eye" style="margin-right:4px;"></i>{{ selectedMom.visible ? 'Visible to all' : 'Restricted' }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="rana-mom-divider"></div>

                                <div class="rana-mom-content">
                                    <app-rt-editor [disabled]="true" [ngModel]="selectedMom.description"></app-rt-editor>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
